import React, {
  memo,
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { format } from 'date-fns';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';
import * as Yup from 'yup';

import { Checkbox, Hidden } from '~/components/Form';
import { Pickers } from '~/components/Form/v2';
import { ButtonUI } from '~/componentsLocal';
import { MODULO_20_GRAUS } from '~/constants/modules';
import { t, number, can } from '~/helpers';
import { transformDateYup } from '~/helpers/dateTime';
import { getToastErrors } from '~/helpers/errorsRequest';
import { validation, validationErrors } from '~/helpers/yupValidations';
import api from '~/services/api';

import seriesmodelo from './seriesmodelo';
import * as S from './styles';

function Historic({ open, data }) {
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState({
    key: 'volumenivel1historicomedicao',
    options: {},
    series: [{ name: '', data: [] }],
  });

  const { language } = useSelector((state) => state.user);

  const formRef = useRef(null);

  const [ctrl20Graus, setCtrl20Graus] = useState('N');
  const [ctrlAgua, setCtrlAgua] = useState('S'); // TODO: ativado por padrao - ate ter o controle se existe ctrl ou nao
  const [densimetro, setDensimetro] = useState('N');

  const [entrada, setEntrada] = useState(true);

  const initialsData = useMemo(
    () => ({
      datahorainicio: format(new Date(), 'yyyy-MM-dd 00:00:00'),
      datahorafim: format(new Date(), 'yyyy-MM-dd 23:59:59'),
      campos: 'volumenivel1historicomedicao',
    }),
    []
  );

  const cores = useMemo(() => [
    '#008FFB',
    '#00E396',
    '#FEB019',
    '#00FFFF',
    '#008B8B',
    '#FF00FF',
    '#FF4500',
    '#FFD700',
    '#8B0000',
    '#7CFC00',
    '#808000',
  ]);

  const campos = useMemo(
    () => [
      {
        label: 'Volume',
        value: 'volumenivel1historicomedicao',
        precision: 0,
        habilitado: 'S',
        habilitadoemgrupo: 'S',
      },
      {
        label: 'Temperatura média',
        value: 'temperaturamediahistoricomedicao',
        precision: 1,
        habilitado: 'S',
        habilitadoemgrupo: 'S',
      },
      /* {
        label: 'Temperatura sensor',
        value: 'temperatura_sensor_historico_medicao',
        precision: 1,
        habilitado: 'S',
        habilitadoemgrupo: 'N',
      },
 */ {
        label: 'Altura',
        value: 'alturanivel1historicomedicao',
        precision: 1,
        habilitado: 'S',
        habilitadoemgrupo: 'S',
      },
      {
        label: 'Volume Água',
        value: 'volumenivel2historicomedicao',
        precision: 0,
        habilitado: ctrlAgua,
        habilitadoemgrupo: 'S',
      },
      {
        label: 'Altura Água',
        value: 'alturanivel2historicomedicao',
        precision: 1,
        habilitado: ctrlAgua,
        habilitadoemgrupo: 'S',
      },
      {
        label: 'Densidade',
        value: 'densidadehistoricomedicao',
        precision: 4,
        habilitado: densimetro,
        habilitadoemgrupo: 'S',
      },
      {
        label: 'Volume 20º C',
        value: 'volume20historicomedicao',
        precision: 0,
        habilitado: ctrl20Graus,
        habilitadoemgrupo: 'S',
      },
    ],
    [ctrl20Graus, ctrlAgua, densimetro]
  );

  const chartOptions = useMemo(
    () => ({
      title: {
        text: data.tafi_codigo,
        align: 'center',
        offsetY: 10,
        style: {
          fontSize: '18px',
          fontWeight: 'bold',
          fontFamily: undefined,
          color: '#000080',
        },
      },
      chart: {
        id: 'grafico',
        type: 'line',
        stacked: false,
        animations: { enabled: false },
        scrollbar: {
          enabled: true,
        },
      },
      noData: {
        text: 'Sem valores',
      },
      dataLabels: { enabled: false },
      stroke: {
        width: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
      },
      xaxis: {},
      yaxis: [],
      legend: {
        horizontalAlign: 'left',
        offsetX: 40,
      },
      scrollbar: {
        enabled: true,
      },
    }),
    [data]
  );

  function createData(name, type) {
    const obj = Object.create(seriesmodelo);
    obj.name = name;
    obj.type = type;
    obj.data = [];
    return obj;
  }

  /*   const handleSensorTemperaturas = async (params) => {
    const request = await api.get('historicosmedicoessensor', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    if (isEmpty(request.data?.pontos_sensor)) {
      toast.error('Não entrou dados no perído para exibir no grafico');
      return;
    }

    let icampos = params.campos;
    if (icampos) {
      icampos = icampos.split(',');
    }
    const selecionados = [];
    const newSeries = [];
    request.data.pontos_sensor.forEach((row) => {
      selecionados.push(row);
      let nome = String(row);
      if (row <= 9) {
        nome = `0${row}`;
      }
      const obj = createData(`${nome}-Sensor`, 'line');
      newSeries.push(obj);
    });
    const qtdeValores = icampos.length;
    const categories = [];
    request.data.historico_medicao_sensor_data_Graf.forEach((row) => {
      categories.push(row.data_historico_medicao);
      row.sensores_valor.forEach((rownovo, index) => {
        // const temp = Number(rownovo).toFixed(2);
        const temp = rownovo;
        newSeries[index].data.push(temp);
      });
    });
    const o = { ...chartOptions };
    o.xaxis = { categories };
    const y = [];
    //  define yaxis
    for (let i = 0; i < qtdeValores; i += 1) {
      y.push({
        seriesName: selecionados[i].label,
        opposite: i !== 0,
        axisTicks: { show: true },
        axisBorder: { show: true, color: cores[i] },
        labels: {
          style: {
            colors: cores[i],
          },
          formatter(val) {
            return number(val, 1);
          },
          // formatter(val) {
          //   return number(val, selecionados[i].precision);
          // },
        },
        title: {
          text: selecionados[i].label,
          style: {
            color: cores[i],
          },
        },
        tooltip: { enabled: true },
        min: 0,
      });
    }
    o.yaxis = y;
    setSeries(newSeries);
    setOpcoesGrafico(o);
    // return;
  };
 */
  const handleGetLoadingHistory = useCallback(
    async (params) => {
      try {
        setLoading(true);

        let icampos = params.campos;

        // if (icampos === 'temperatura_sensor_historico_medicao') {
        //   // TODO: para o futuro
        //   await handleSensorTemperaturas(params);
        // } else {
        const request = await api.get('historicosmedicoestanques/grafico', {
          params,
          paramsSerializer: (param) => qs.stringify(param),
        });

        // let icampos = params.campos;

        if (icampos) {
          icampos = icampos.split(',');
        }

        const selecionados = [];

        for (let i = 0; i < icampos.length; i += 1) {
          for (let j = 0; j < campos.length; j += 1) {
            if (icampos[i] === campos[j].value) {
              selecionados.push(campos[j]);
              break;
            }
          }
        }

        const qtdeValores = icampos.length;
        const newChartKey = `${data.graphic?.idtanquefisico || ''}-${params.campos}`;

        // valores
        const valores1 = [];
        const valores2 = [];
        const valores3 = [];

        // popula os dados
        request.data.forEach((row) => {
          valores1.push(row.valor1);
          if (qtdeValores > 1) {
            valores2.push(row.valor2);
          }
          if (qtdeValores > 2) {
            valores3.push(row.valor3);
          }
        });

        // configura options
        const o = { ...chartOptions };

        const categories = request.data.map(
          (category) => category.data_historico_medicao
          // new Date(category.data_historico_medicao).toLocaleString(language)
        );

        // configura xaxis - categories
        o.xaxis = { categories };

        const y = [];

        //  define yaxis
        for (let i = 0; i < qtdeValores; i += 1) {
          y.push({
            seriesName: selecionados[i].label,
            opposite: i !== 0,
            axisTicks: { show: true },
            axisBorder: { show: true, color: cores[i] },
            labels: {
              style: {
                colors: cores[i],
              },
              formatter(val) {
                return number(val, selecionados[i].precision);
              },
            },
            title: {
              text: selecionados[i].label,
              style: {
                color: cores[i],
              },
            },
            tooltip: { enabled: true },
            min: 0,
          });
        }

        o.yaxis = y;

        // configura series
        let newSeries;
        if (qtdeValores === 1) {
          newSeries = [
            { name: selecionados[0].label, type: 'line', data: valores1 },
          ];
        } else if (qtdeValores === 2) {
          newSeries = [
            { name: selecionados[0].label, type: 'line', data: valores1 },
            { name: selecionados[1].label, type: 'line', data: valores2 },
          ];
        } else {
          newSeries = [
            { name: selecionados[0].label, type: 'line', data: valores1 },
            { name: selecionados[1].label, type: 'line', data: valores2 },
            { name: selecionados[2].label, type: 'line', data: valores3 },
          ];
        }

        setChartData({
          key: newChartKey,
          options: o,
          series: newSeries,
        });
        // }
      } catch (err) {
        getToastErrors(err);
      } finally {
        setLoading(false);
      }
    },
    [language, data]
  );

  const handleSubmit = useCallback(
    async (formData) => {
      setEntrada(false);
      formData.itens = '';
      campos.forEach((campo, index) => {
        if (formData[`campo${index}`]) {
          if (formData.itens) {
            formData.itens += ',';
          }
          formData.itens += campo.value;
        }
      });

      if (!formData.itens) {
        toast.error('Escolha pelo menos um item para exibir o gráfico');
        return;
      }

      if (formData.itens.split(',').length > 3) {
        toast.error('Escolha no máximo 3 valores para exibição no gráfico');
        return;
      }

      /*
      // se o processo de validação no campo falhar!
      if (formData.itens.split(',').length <= 3) {
        // const split_string = formData.itens.split(',');
        const found = formData.itens
          .split(',')
          .find((value) => value === 'temperatura_sensor_historico_medicao');
        if (found && formData.itens.split(',').length > 1) {
          toast.error('Somente o item temperatura sensor deve ser selecionado');
          return;
        }
      }
      */

      try {
        const schema = Yup.object().shape({
          datahorainicio: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          datahorafim: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
        });

        await validation(schema, formData);

        const start = format(
          transformDateYup(formData.datahorainicio),
          'yyyy-MM-dd HH:mm:ss'
        );

        const end = format(
          transformDateYup(formData.datahorafim),
          'yyyy-MM-dd HH:mm:ss'
        );

        const listaCampos = formData.itens;

        await handleGetLoadingHistory({
          idposto: data.graphic.idposto,
          idtanque: data.graphic.idtanquefisico,
          datahorainicio: start,
          datahorafim: end,
          campos: listaCampos,
        });
      } catch (err) {
        validationErrors(err, formRef);
      }
    },
    [data]
  );

  useEffect(() => {
    if (open && !isEmpty(initialsData) && !isEmpty(data)) {
      setCtrl20Graus(can(MODULO_20_GRAUS) ? 'S' : 'N');
      setDensimetro(can(MODULO_20_GRAUS) ? 'S' : 'N');
      /* TODO: da base
      setCtrlAgua(data.controla_agua_tanque);
      */
      // exibicao inicial
      handleGetLoadingHistory({
        idposto: data.graphic.idposto,
        idtanque: data.graphic.idtanquefisico,
        ...initialsData,
      });
    }
  }, [open, initialsData, data]);

  function handleVerificaHabilita() {
    const camposlista = [];
    campos.forEach((row, index) => {
      if (formRef.current.getFieldValue(`campo${index}`)) {
        camposlista.push(`campo${index}`);
      }
    });
    if (camposlista.length > 0) {
      const found = camposlista.find((element) => element === 'campo2');
      if (found) {
        /* camposlista.forEach((row, index) => {
          if (camposlista[index] !== 'campo2') {
            formRef.current.setFieldError(
              camposlista[index],
              'Não é possivel esse filtro se temperatura sensor estiver selecionado'
            );
          }
        }); */
        formRef.current.submitForm();
      } else {
        formRef.current.setErrors({});
      }
    }
  }

  // teste de commit apenas
  if (open)
    return (
      <S.Wrapper>
        <S.Graphic>
          <Chart
            key={chartData.key}
            height="96%"
            options={chartData.options}
            series={chartData.series}
            type="line"
          />
        </S.Graphic>
        <S.Sidebar
          ref={formRef}
          initialData={initialsData}
          onSubmit={handleSubmit}
        >
          <Hidden name="itens" value="" />

          <Pickers
            time
            name="datahorainicio"
            label={t('s.geral.opcoes.datahorainicial')}
            disabled={loading}
          />

          <Pickers
            time
            disableFuture
            name="datahorafim"
            label={t('s.geral.opcoes.datahorafinal')}
            disabled={loading}
          />

          {campos.map((campo, index) => (
            <Checkbox
              name={`campo${index}`}
              label={campo.label}
              disabled={campo.habilitado === 'N'}
              checked={index === 0 ? entrada : false}
              getValue={() => handleVerificaHabilita()}
            />
          ))}

          <ButtonUI
            fullWidth
            type="submit"
            variant="contained"
            color="primary"
            loading={loading}
            disabled={loading}
          >
            {t('c.global.filtrar')}
          </ButtonUI>
        </S.Sidebar>
      </S.Wrapper>
    );

  return <div />;
}

Historic.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(
    PropTypes.shape({
      id_tanque: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ),
};

Historic.defaultProps = {
  data: {},
};

export default memo(Historic);
